'use strict';

const VERSION = '1.0.0';
const NAME = 'scripts-cart';

const Calendar = require('./calendar');

let deliveryCity;
let selectedDate;
let selectedDateString;

let invoiceForCompany;
let invoiceForCompanyInput;
let companyFieldset;

let formCart;
let formCheckout;
let sendOrderButton;
let cartErrorNotification;

function canChangeElement(element) {
    // return ['SELECT'].indexOf(element.tagName) === -1
    //     && ['hidden'].indexOf(element.type) === -1;
    if (element.getAttribute('data-select')) return false;
    return ['hidden'].indexOf(element.type) === -1;
}

function updateForSelect(select) {
    let dataSelect = select.getAttribute('data-select');
    let data;
    try {
        data = JSON.parse(select.selectedOptions[0].getAttribute('data'));
    } catch (e) {

    }
    if (!data) {
        // reset
        document.querySelectorAll(`[name^="${dataSelect}"]`).forEach(element => {
            if (canChangeElement(element)) {
                let defaultValue = element.getAttribute('data-default-value');
                if (defaultValue) {
                    element.value = defaultValue;
                } else {
                    element.value = "";
                }
                element.disabled = false;
            }
        });
        return;
    }
    // console.log('data-select', 'change', dataSelect, data);
    Object.keys(data).forEach(key => {
        let element = document.querySelector(`[name="${dataSelect}.${key}"]`);
        if (element) {
            if (canChangeElement(element)) {
                element.value = data[key];
                element.disabled = true;
            }
        }
    });
}

function init(options) {
    console.log(NAME, 'init');

    document.querySelectorAll('[data-select]').forEach(select => {
        select.addEventListener('change', evt => {
            // console.log('data-select', 'change', evt.target, evt.currentTarget);
            updateForSelect(evt.target);
        });
        updateForSelect(select);
    });

    document.querySelectorAll(`input[name='quantity']`).forEach(element => {
        element.addEventListener('change', evt => {
            evt.currentTarget.parentNode.submit();
        });
    });

    formCart = document.querySelector(`form[name='cart']`);
    formCheckout = document.querySelector(`form[name='checkout']`);

    if (formCart) {
        initCart(options);
        return;
    }

    if (formCheckout) {
        initCheckout(options);
        return;
    }

    return false;
}

function initCart(options) {
    console.log(NAME, 'initCart');

    calendarOptions.language = language;

    deliveryCity = calendarOptions.selectedCity;
    if (calendarOptions.selectedDate) {
        selectedDateString = calendarOptions.selectedDate;
        selectedDate = new Date(calendarOptions.selectedDate);
    }

    let calendar = new Calendar(document.querySelector(`.calendarContainer`),
        calendarOptions,
        (_selectedDate, _selectedDateString) => {
            selectedDate = _selectedDate;
            selectedDateString = _selectedDateString;
            // console.log(selectedDate, selectedDateString);
            updateCartUI();
        }
    );

    document.querySelectorAll(`select[name='city']`).forEach(select => {
        select.addEventListener('change', evt => {
            let element = evt.target;
            let option = element.selectedOptions[0];
            // console.log(option);
            deliveryCity = {
                price: parseInt(option.getAttribute('data-price'), 10),
                hasSameDayDelivery: option.hasAttribute('data-same-day'),
            };
            // console.log(deliveryCity);
            calendar.updateDeliveryCity(deliveryCity);
            updateCartUI();
        });
    });

    cartErrorNotification = document.querySelector(`.is-cart-error`);

    sendOrderButton = document.querySelector(`#send_order`);
    sendOrderButton.setAttribute('href', '#send_order');
    sendOrderButton.addEventListener('click', evt => {
        evt.preventDefault();
        if (is.nue(deliveryCity)) {
            let message = language === 'ro' ? 'Alege un oraș și o dată de livrare validă.' : 'Choose a valid delivery city and date.';
            if (cartErrorNotification) {
                cartErrorNotification.classList.remove('is-hidden');
                cartErrorNotification.innerHTML = message;
            } else {
                alert(message);
            }
            return;
        }
        if (is.nue(selectedDate)) {
            let message = language === 'ro' ? 'Alege o dată de livrare validă.' : 'Choose a valid delivery date.';
            if (cartErrorNotification) {
                cartErrorNotification.classList.remove('is-hidden');
                cartErrorNotification.innerHTML = message;
            } else {
                alert(message);
            }
            return;
        }
        if (cartErrorNotification) {
            cartErrorNotification.classList.add('is-hidden');
            cartErrorNotification.innerHTML = '';
        }

        // console.log(deliveryCity, selectedDate);
        // return;

        formCart.submit();
        document.querySelectorAll(`.isEAM`).forEach(element => {
            element.parentNode.removeChild(element);
        });
    });

    formCart.addEventListener('submit', evt => {
        evt.preventDefault();
        return false;
    });
}

function updateCartUI() {
    // console.log('updateCartUI', pricing.itemsTotal, deliveryCity.price);
    let total = pricing.itemsTotal;
    let shippingPrice = 0;
    if (deliveryCity) {
        shippingPrice = deliveryCity.price;
        total += shippingPrice;
    }
    document.querySelectorAll(`.total`).forEach(element => {
        element.innerHTML = `${total} ${currencyCode}`;
    });
    document.querySelectorAll(`.shippingPrice`).forEach(element => {
        element.innerHTML = `${shippingPrice} ${currencyCode}`;
    });

    if (cartErrorNotification) {
        cartErrorNotification.classList.add('is-hidden');
        cartErrorNotification.innerHTML = '';
    }
}

function initCheckout(options) {
    console.log(NAME, 'initCheckout');

    companyFieldset = document.querySelector('#company');
    invoiceForCompanyInput = document.querySelector('input[type="checkbox"][name="invoiceForCompany"]');
    invoiceForCompanyInput.addEventListener('change', e => {
        invoiceForCompany = invoiceForCompanyInput.checked;
        updateCheckoutUI();
    });
    invoiceForCompany = invoiceForCompanyInput.checked;

    sendOrderButton = document.querySelector('#send_order');
    formCheckout.addEventListener('submit', evt => {
        if (sendOrderButton) {
            sendOrderButton.classList.add('is-hidden');
            sendOrderButton.parentNode.querySelector('progress.progress').classList.remove('is-hidden');
        }
    });

    updateCheckoutUI();
}

function updateCheckoutUI() {
    if (invoiceForCompany === true) {
        companyFieldset.classList.remove('is-hidden');
    } else {
        companyFieldset.classList.add('is-hidden');
    }
}

module.exports = {
    VERSION: VERSION,
    NAME: NAME,

    init: init,
};